import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e306e70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-box" }
const _hoisted_2 = { class: "calendar-top" }
const _hoisted_3 = { class: "flex-box" }
const _hoisted_4 = { class: "title-center" }
const _hoisted_5 = { class: "flex-box" }
const _hoisted_6 = { class: "big-calendar-clr" }
const _hoisted_7 = { class: "calendar-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ant_icon = _resolveComponent("ant-icon")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "topLeft", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.hasStartTime || (_ctx.activeYear > _ctx.startObj?.year || (_ctx.activeYear === _ctx.startObj?.year && _ctx.active > _ctx.startObj?.month - 1)))
          ? (_openBlock(), _createBlock(_component_ant_icon, {
              key: 0,
              onClick: _ctx.leftHD,
              type: "LeftOutlined"
            }, null, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_ant_icon, {
              key: 1,
              type: "LeftOutlined",
              style: {"opacity":".4","cursor":"no-drop"}
            })),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.activeYear) + "年 " + _toDisplayString(_ctx.active + 1) + "月", 1),
        (!_ctx.hasDeadline || (_ctx.activeYear < _ctx.nowObj?.year || (_ctx.activeYear === _ctx.nowObj?.year && _ctx.active < _ctx.nowObj?.month - 1)))
          ? (_openBlock(), _createBlock(_component_ant_icon, {
              key: 2,
              onClick: _ctx.rightHD,
              type: "RightOutlined"
            }, null, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_ant_icon, {
              key: 3,
              type: "RightOutlined",
              style: {"opacity":".4","cursor":"no-drop"}
            }))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "topRight", {}, undefined, true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_swiper, {
        class: "calendar-swiper swiper-no-swiping",
        onSwiper: _ctx.onSwiper
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateArr, (item, index) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (cell, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["calendar-item-content", { 'noNow': cell.month !== 'now' }])
                    }, [
                      _createTextVNode(_toDisplayString(cell?.content) + " ", 1),
                      _renderSlot(_ctx.$slots, "item", { record: cell }, undefined, true)
                    ], 2))
                  }), 256))
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 3
      }, 8, ["onSwiper"])
    ])
  ]))
}